module.exports = __webpack_public_path__ + "img/HongKongTrustSwper2.53c740cf.jpg";